import type { IconData } from '@stacksjs/iconify-core'

export const shoppingJewels: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 7V5l4-4h8l4 4v2l-8 8zm14-1l-3-3l-3 3z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default shoppingJewels
